var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_491)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91663 4C1.91663 2.48122 3.14784 1.25 4.66663 1.25H9.75218C10.4815 1.25 11.181 1.53973 11.6967 2.05546L13.2778 3.63657C13.7936 4.15229 14.0833 4.85177 14.0833 5.58111V12C14.0833 13.5188 12.8521 14.75 11.3333 14.75H4.66663C3.14784 14.75 1.91663 13.5188 1.91663 12V4ZM4.66663 2.75C3.97627 2.75 3.41663 3.30964 3.41663 4V12C3.41663 12.6904 3.97627 13.25 4.66663 13.25H11.3333C12.0236 13.25 12.5833 12.6904 12.5833 12V5.58111C12.5833 5.24959 12.4516 4.93165 12.2172 4.69723L10.6361 3.11612C10.4016 2.8817 10.0837 2.75 9.75218 2.75H4.66663Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66663 1.5C9.94277 1.5 10.1666 1.72386 10.1666 2V4.33333C10.1666 4.79357 10.5397 5.16667 11 5.16667H13.3333C13.6094 5.16667 13.8333 5.39052 13.8333 5.66667C13.8333 5.94281 13.6094 6.16667 13.3333 6.16667H11C9.98744 6.16667 9.16663 5.34586 9.16663 4.33333V2C9.16663 1.72386 9.39048 1.5 9.66663 1.5Z",
    className: "icon-fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.1b2570c45494aea72da4983f419fb25b.svg";
export { ForwardRef as ReactComponent };